import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/utils/cn';

const LINKS = [
  { to: '/giving', end: true, labelKey: 'nav.contributions' as const },
  { to: '/giving/tithes', end: false, labelKey: 'nav.tithes' as const },
  { to: '/giving/services', end: false, labelKey: 'nav.services' as const },
  { to: '/giving/funds', end: false, labelKey: 'nav.funds' as const },
  { to: '/giving/types', end: false, labelKey: 'nav.types' as const },
  { to: '/giving/periods', end: false, labelKey: 'nav.periods' as const },
];

export const GivingSubnav = () => {
  const { t } = useTranslation('giving');

  return (
    <nav className="mb-4 flex flex-wrap gap-2" aria-label={t('title')}>
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            cn(
              'rounded-md px-3 py-1.5 text-body-sm',
              isActive
                ? 'bg-brand/10 font-medium text-brand'
                : 'text-fg-secondary hover:bg-surface-muted hover:text-fg',
            )
          }
        >
          {t(link.labelKey)}
        </NavLink>
      ))}
    </nav>
  );
};
